import useParagraphLineClamped from '@/hooks/useLineClamped';
import useToggle from '@/hooks/useToggle';
import { Typography } from 'design-system/components/Typography';

const CollectionDetailDescription = ({
  description,
}: {
  description: string;
}) => {
  const { contentRef, maxHeight, isClamped } = useParagraphLineClamped({
    linesAllowed: 5,
    dependencies: [description],
  });

  const [seeMore, toggleSeeMore] = useToggle();

  return (
    <Typography
      variant="body3"
      ref={contentRef}
      style={{
        maxHeight: seeMore ? 'none' : maxHeight,
        overflowY: 'hidden',
      }}
      className="relative whitespace-pre-line bg-transparent leading-[140%] text-Text/Lightbackground/Secondary break-word-legacy"
    >
      {description}
      {isClamped && (
        <span
          className={`${!seeMore ? 'absolute bottom-0 right-0 bg-white' : ''}`}
        >
          {!seeMore && <span className="inline text-Primary/Main">... </span>}
          <span
            onClick={toggleSeeMore}
            className="inline cursor-pointer text-Primary/Main hover:underline"
          >
            {seeMore ? ' Thu gọn' : 'Xem thêm'}
          </span>
        </span>
      )}
    </Typography>
  );
};

export default CollectionDetailDescription;
